import React from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface Props {
  onCreateNew: () => void
  selectTextClassName?: string
}

const CreateNewClientMessage: React.FC<Props> = ({
  onCreateNew,
  selectTextClassName,
}) => {
  return (
    <p className={cn('mb-2', 'text-black', selectTextClassName)}>
      Not on the list?{' '}
      <Button variant="plain" className="underline" onClick={onCreateNew}>
        Create a new client
      </Button>{' '}
    </p>
  )
}

export default CreateNewClientMessage
